import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../services/admin/admin.service';
import { PetitionCategory } from '../../../../shared/admin-models/interfaces/petition-category.interface';
import { Response } from '../../../../shared/admin-models/classes/response.class';
import { TdLoadingService } from '@covalent/core';
import { MatDialog, MatSnackBar, MatTableDataSource } from '@angular/material';
import { AddEditCategoryDialogComponent } from './dialogs/add-edit-category-dialog/add-edit-category-dialog.component';
import { ConfirmationDialogComponent } from '../shared/petition-details/dialogs/review-results-dialog/dialogs/confirmation-dialog/confirmation-dialog.component';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-categories-panel',
  templateUrl: './categories-panel.component.html',
  styleUrls: ['./categories-panel.component.scss']
})
export class CategoriesPanelComponent implements OnInit {
  paging = {
    page: 0,
    size: 10
  };
  dataSource: MatTableDataSource<PetitionCategory>;
  displayedColumns = ['title', 'description', 'action'];
  totalNumber: number;
  constructor(
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar,
    private _dialogRef: MatDialog
  ) {}

  ngOnInit() {
    this.getCategories();
  }
  getCategories(): void {
    this._loadingService.register();
    this._adminService.findAdminCategories(this.paging).subscribe(
      (res: Response<PetitionCategory[]>) => {
        this._loadingService.resolve();
        this.dataSource = new MatTableDataSource(res.result.data);
        this.totalNumber = res.result.page.total;
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  pageEvent(e) {
    this.paging = e;
    this.getCategories();
  }
  openAddEditCategoryDialog(mode: string, category?: PetitionCategory) {
    const dialogRef = this._dialogRef.open(AddEditCategoryDialogComponent, {
      data: category ? { id: category.id, mode: mode } : { mode: mode },
      width: '650px'
    });
    dialogRef.afterClosed().subscribe((res: string) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this.getCategories();
      }
    });
  }
  deleteCategory(category: PetitionCategory) {
    const confirmationDialog = this._dialogRef.open(
      ConfirmationDialogComponent,
      {
        width: '25%',
        data: {
          title: `დარწმუნებული ხართ, რომ გსურთ მითითებული კატეგორიის-${category.title} წაშლა?`
        }
      }
    );
    confirmationDialog.afterClosed().subscribe((res: boolean) => {
      if (res) {
        this._loadingService.register();
        this._adminService.deleteCategory(category.id).subscribe(() => {
          this._loadingService.resolve();
          this.getCategories();
        });
      }
    });
  }

    imageFileId(imageFileId: string): string {
        return new URL(`/idea/file/${imageFileId}`, environment.apiUlr).toString()
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/categories-panel/categories-panel.component.ts